import React, { useEffect, useState } from "react";
import UserProfilePicture from "./UserProfilePicture";
import { getAllUsers, UserData } from "../lib/auth";

interface DirectMessagingDemoProps {
  currentUser: {
    userId: string;
    email: string;
    displayName: string;
  };
}

const DirectMessaging: React.FC<DirectMessagingDemoProps> = ({
  currentUser,
}) => {
  const [users, setUsers] = useState<UserData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        setError(null);
        const fetchedUsers = await getAllUsers();
        setUsers(fetchedUsers);
      } catch (err) {
        console.error("Failed to fetch users:", err);
        setError("Failed to load users. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // Demo users as fallback when no real users are available
  const demoUsers2 = [
    {
      uid: "",
      email: "",
      displayName: "Add a connection so you can chat!",
      photoURL: "",
      createdAt: new Date(),
      updatedAt: new Date(),
    },
  ];

  const demoUsers = [
    {
      uid: "demo1",
      email: "alice@example.com",
      displayName: "Alice Johnson",
      photoURL:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    {
      uid: "demo2",
      email: "bob@example.com",
      displayName: "Bob Smith",
      photoURL:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    {
      uid: "demo3",
      email: "carol@example.com",
      displayName: "Carol Davis",
      photoURL:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      createdAt: new Date(),
      updatedAt: new Date(),
    },
  ];

  // Use real users if available, otherwise show demo users
  const displayUsers = users.length > 0 ? users : demoUsers2;

  if (loading) {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "8px",
          margin: "20px",
        }}
      >
        <h3 style={{ marginBottom: "20px", color: "#333" }}>
          Loading Users...
        </h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              border: "3px solid #e5e7eb",
              borderTop: "3px solid #1876f2",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "8px",
          margin: "20px",
        }}
      >
        <h3 style={{ marginBottom: "20px", color: "#333" }}>Users</h3>
        <div
          style={{
            padding: "20px",
            backgroundColor: "#fef2f2",
            borderRadius: "6px",
            border: "1px solid #fecaca",
            textAlign: "center",
          }}
        >
          <p style={{ color: "#dc2626", margin: "0 0 10px 0" }}>{error}</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 16px",
              backgroundColor: "#1876f2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Refresh
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "10px",
        backgroundColor: "#333",
        borderRadius: "8px",
      }}
    >
      <h3
        style={{
          marginBottom: "20px",
          color: "#fff",
          borderBottom: "2px solid #767676",
          paddingBottom: "10px",
        }}
      >
        {/* {users.length > 0 && (
          <span
          style={{ fontSize: "14px", color: "#666", fontWeight: "normal" }}
          >
          {" "}
          ({users.length})
          </span>
          )} */}
        Chat
      </h3>

      {/* {users.length === 0 && (
        <div
          style={{
            marginBottom: "20px",
            padding: "10px",
            backgroundColor: "#fff3cd",
            borderRadius: "4px",
            border: "1px solid #ffeaa7",
          }}
        >
          <p style={{ margin: 0, color: "#856404", fontSize: "14px" }}>
            📝 No other users found. Create more accounts to test real
            messaging! Showing demo users for now.
          </p>
        </div>
      )} */}

      {/* <p style={{ marginBottom: "20px", color: "#666", fontSize: "14px" }}>
        Click on any profile picture below to start a chat conversation:
      </p> */}

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {displayUsers.map((user) => (
          <div key={user.uid} style={{ textAlign: "center" }}>
            <UserProfilePicture
              user={{
                userId: user.uid,
                email: user.email,
                displayName: user.displayName,
                photoURL:
                  user.photoURL ||
                  `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    user.displayName
                  )}&size=60&background=1876f2&color=ffffff`,
              }}
              currentUser={currentUser}
              size={40}
              showChatOnClick={true}
            />
            <p
              style={{
                marginTop: "8px",
                fontSize: "12px",
                color: "#fff",
                maxWidth: "80px",
                wordWrap: "break-word",
              }}
            >
              {user.displayName}
            </p>
            {/* <p
              style={{
                marginTop: "2px",
                fontSize: "10px",
                color: "#999",
                maxWidth: "80px",
                wordWrap: "break-word",
              }}
            >
              {user.email}
            </p> */}
          </div>
        ))}
      </div>

      {/* <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '6px' }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#0369a1', fontSize: '16px' }}>Features:</h4>
        <ul style={{ margin: 0, paddingLeft: '20px', color: '#374151', fontSize: '14px' }}>
          <li>Real-time messaging with Firebase Firestore</li>
          <li>File uploads (images and documents) with Firebase Storage</li>
          <li>Message history with proper date grouping</li>
          <li>Drag and drop file upload</li>
          <li>Facebook-style narrow chat interface</li>
          <li>Auto-scroll to new messages</li>
          <li>Message timestamps and delivery status</li>
          <li>✨ Now loads real users from your Firebase database!</li>
        </ul>
      </div> */}

      {/* {users.length > 0 && (
        <div
          style={{
            marginTop: "15px",
            padding: "10px",
            backgroundColor: "#d1fae5",
            borderRadius: "4px",
          }}
        >
          <p style={{ margin: 0, color: "#065f46", fontSize: "12px" }}>
            🎉 Great! You have {users.length} registered user
            {users.length !== 1 ? "s" : ""} in your database. Try opening
            another browser window and creating more accounts to test the chat!
          </p>
        </div>
      )} */}
    </div>
  );
};

export default DirectMessaging;
